import { ArrowForward, DirectionsBoat, FeaturedPlayList } from "@mui/icons-material";
import { useTranslation } from "react-i18next";
import { M_Fieldset } from "src/M_Components";
import { AgreementFormField } from "./AgreementFormField";

export const AgreementDetails = ({ dataState, setDataState }) => {
  const { t } = useTranslation()

  return (
    <>
      <M_Fieldset
        labelInside
        label={
          <div
            style={{
              display: "flex",
              alignItems: "center",
              fontSize: "25px",
              marginLeft: "10px",
            }}
          >
            <ArrowForward style={{ marginRight: "10px", scale: "1.3" }} />{" "}
            {t("Details")}
          </div>
        }
        elements={
          <div
            style={{
              display: "flex",
              flexWrap: "wrap"
            }}
          >
            <AgreementFormField label={t("Code")} type="text" code="Code" data={dataState} setData={setDataState} />
            <AgreementFormField label={t("Name")} type="text" code="Name" data={dataState} setData={setDataState} />
            <AgreementFormField label={t("Description")} type="text" code="Description" data={dataState} setData={setDataState} />
            <AgreementFormField label={t("Endmonth")} type="text" code="Endmonth" data={dataState} setData={setDataState} />
            <AgreementFormField label={t("Nextmonth")} type="text" code="Nextmonth" data={dataState} setData={setDataState} />
            <AgreementFormField label={t("Days")} type="number" code="Days" data={dataState} setData={setDataState} />
            <AgreementFormField label={t("FixDay")} type="number" code="Fix_day" data={dataState} setData={setDataState} />
          </div>
        }
      />
    </>
  )
}